import AuthListener from './firebase/AuthListener';

const DataLayer = () => {
	// handle firebase user login status
	AuthListener();

	// todo

	return null;
};

export default DataLayer;
